import React from "react";
import { useSearch } from "../contexts/SearchContext";
import styled from "styled-components";

const SearchBar = () => {
  const { setModalOpen } = useSearch();

  return (
      <SearchButton onClick={() => setModalOpen(true)}>
        <i className="material-icons flaticon-search"></i>
      </SearchButton>
  );
};

const SearchButton = styled.button`
    width: 35px;
    height: 35px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    cursor: pointer;
    border: 1px solid #aaa;
    background-color: transparent;
    color: black;
    transition: all ease 300ms;
    
    &:hover {
        background-color: var(--bs-primary);
        color: white;
    }
`;

export default SearchBar;
